import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const PreviewModal = ({
  show,
  onHide,
  title,
  fileUrl,
  fileType,
}) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ minHeight: 400 }}>
        {fileType == "image" && (
          <img src={fileUrl} alt={title} style={{ width: "100%" }} />
        )}
        {fileType == "pdf" && (
          <iframe
            src={fileUrl}
            title="PDF Document"
            style={{ width: "100%", height: "500px", border: "none" }}
          />
        )}
        {fileType === "doc" && (
          <iframe
            src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(fileUrl)}`}
            title="DOC Document"
            style={{ width: "100%", height: "500px", border: "none" }}
          />
        )}
        {!fileType && (
          <div>{t("Cannot preview this file type.")}</div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default PreviewModal;